import request from '../helpers'

const state = {
  loading: false
}

const mutations = {
  CHANGE_LOADING_STATE(state, loading) {
    state.loading = loading
  }
}

const actions = {
  savePage({ commit, dispatch }, data) {
    return request({ 
      commit: commit, 
      method: data.id == undefined || data.id == 0 ? 'put' : 'post', 
      url: `causes/${data.causeId}/pages`,
      data: data, 
      successCallback: page => {
        dispatch('causes/updatePage', page, { root: true })
      }
    });
  },
  changeHomePage({ commit }, data) {
    return request({ 
      commit: commit, method: 'post', 
      url: `causes/${data.causeId}/pages/home?currentHomeId=${data.currentHomeId}&newHomeId=${data.newHomeId}`, 
      successCallback: pages => {
        commit('causes/UPDATE_PAGE', pages[0], { root: true })
        commit('causes/UPDATE_PAGE', pages[1], { root: true })
      }
    });
  },
  changePagesOrder({ commit }, data) {
    return request({ 
      commit: commit, method: 'post', 
      url: `causes/${data.causeId}/pages/order`,
      data: data.pages, 
      successCallback: pages => {
        commit('causes/UPDATE_PAGES', pages, { root: true })
      }
    });
  }
}

const getters = {
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}